<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">Bad Debts</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn 
              @click.stop="dialog = true"
              class="primary white--text">
              <v-icon>close</v-icon>
            </v-btn>  
          </v-card-actions>
        </v-toolbar>
      </v-card>
    

    <v-data-table
        :headers="headers"
        :items="filteredInvoices"
        class="elevation-1"
    >
       <template slot="items" slot-scope="props">
          <td class="text-xs-left nowrap"><b>{{ props.item.buyerName }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.propName }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.buyerId }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.mobile }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.village }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.block }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.tehsil }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.district }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.mobileNo }}</b></td>
        </template>
    </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

export default {
  data () {
    return {
        headers: [
        { text: 'Buyer Name', sortable: false, value: 'buyerName' },
        { text: 'Father Name', sortable: false, value: 'propName' },
        { text: 'Buyer ID', sortable: false, value: 'buyerId' },
        { text: 'Village', sortable: false, value: 'village' },
        { text: 'Block', sortable: false, value: 'block' },
        { text: 'Tehsil', sortable: false, value: 'tehsil' },
        { text: 'District', sortable: false, value: 'district' },
        { text: 'Mobile No', sortable: false, value: 'mobileNo' },
      ],
      firms: {},
      buyerById: {}
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Informations/Defaultersheet/index.vue